'use client';

import { createContext, type ReactNode, useContext, useRef } from 'react';
import { useStore } from 'zustand';
import { createUserStore, type UserState, type UserStore } from './userStore';
export type UserStoreApi = ReturnType<typeof createUserStore>;
export const UserStoreContext = createContext<UserStoreApi | undefined>(undefined);
export interface UserStoreProviderProps {
  children: ReactNode;
  initState?: UserState;
}
export const UserStoreProvider = ({
  children,
  initState
}: UserStoreProviderProps) => {
  const storeRef = useRef<UserStoreApi | null>(null);
  if (storeRef.current === null) {
    storeRef.current = createUserStore(initState);
  }
  return <UserStoreContext.Provider value={storeRef.current}>{children}</UserStoreContext.Provider>;
};
export const useUserStore = selector => {
  const userStoreContext = useContext(UserStoreContext);
  if (!userStoreContext) {
    throw new Error("useUserStore must be used within UserStoreProvider");
  }
  return useStore(userStoreContext, selector);
};